import { URLS } from '../../../constants';
import apiClient from '../../client';

const AuthorizationsGridApi = {
  AuthorizationsGrid: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
  }: {
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: any;
  }) =>
    apiClient.post(URLS.authorizationGrid, {
      data: {
        heading,
        roleId,
        type,
        pagination,
        assignedTo,
        filter: [...filterValue],
        sorting: {
          order: order?.toLocaleUpperCase() || 'DESC',
          fieldName: name || 'createdDate',
        },
      },
    }),
  authorizationBillingCodes: () =>
    apiClient.post(URLS.authorizationBillingCodes, {
      data: {},
    }),
  claimSettingForWaystar: ({
    organizationSpecificId,
    isSendClaimToWaystarEnabled,
    isClaimMoniteringEnabled,
  }: {
    organizationSpecificId: any;
    isSendClaimToWaystarEnabled: any;
    isClaimMoniteringEnabled: any;
  }) =>
    apiClient.post(URLS.claimSetting, {
      data: {
        organizationSpecificId,
        isSendClaimToWaystarEnabled,
        isClaimMoniteringEnabled,
      },
    }),
  getWaystarStatus: ({ organizationSpecificId }: { organizationSpecificId: string }) => {
    return apiClient.post(URLS.getWaystarStatus, {
      data: {
        organizationSpecificId,
      },
    });
  },
};
export default AuthorizationsGridApi;
